import { getNextTaskId } from "./common";
import { uid } from "@xbs/lib-state";
export function deleteSelectedTasks({ store }) {
    const selected = store.getState().selected;
    if (!selected.length)
        return;
    let nextSelect = getNextTaskId({ store, id: selected.at(-1) });
    if (store.getTask(nextSelect)?.selected) {
        nextSelect = getNextTaskId({ store, id: selected.at(0) });
    }
    let $meta;
    let batch = selected;
    if (selected.length > 1) {
        $meta = { batch: uid() };
    }
    store.eachSelected((id, index) => {
        if (store.existsTask(id)) {
            if (!index) {
                store.in.exec("delete-task", { id, batch, $meta });
            }
            else {
                store.in.exec("delete-task", {
                    id,
                    skipProvider: true,
                    batch,
                    $meta,
                });
            }
        }
    }, true);
    store.in.exec("select-task", {
        id: nextSelect,
    });
}
//# sourceMappingURL=delete.js.map